import { useContext } from 'react'
import { CommentsContext } from '../Context/CommentsContext'

function useCommentsContext() {
  const comments = useContext(CommentsContext)

  if (!comments) {
    throw new Error('useCommentsContext must be used within a CommentsProvider')
  }

  return comments
}

export { useCommentsContext }
